/**
 * Home ("/") — minimal marketplace browse.
 *
 * The Phase 10 tools-hero landing was rolled back per user; `/` now renders
 * the same Inventory grid as `/inventory` so the front door is a plain,
 * scannable list of vehicles. Finance / Trade-in tools live on the vehicle
 * detail page (Phase 7 placement).
 */
import React from "react";
import Inventory from "@/pages/Inventory";

const Home = () => <Inventory />;

export default Home;
